import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { handleClose } from "./HandleClosePop/handleclose";
import { setBankInfos } from "../../Slices/employeeslice";
import Modal from "../../blueplanitUtils/Modal";
import { InputField } from "../../blueplanitUtils/InputField";
export const BankInfoModelPopUp = () => {
  const dispatch = useDispatch();
  const {handleSubmit}=useFormHandler()
  const [isBankInfoFormValid, setIsBankInfoFormValid] = useState(false);
  const bankInfoup = useSelector((state) => state.employee.BankInfos);
  useEffect(() => {
    setBankInfo({
      BankAccountNo: bankInfoup?.BankAccountNo || '',
      Branch: bankInfoup?.Branch || '',
      IFCcode: bankInfoup?.IFCcode || '',
      BankName: bankInfoup?.BankName || '',
      PanNumber: bankInfoup?.PanNumber || '',
    });
  }, [bankInfoup])

  const [bankInfo, setBankInfo] = useState({
    BankAccountNo: '',
    BankName: '',
    IFCcode: '',
    Branch: '',
    PanNumber: '',
  });

  const [Bankerrors, setBankErrors] = useState({});
  const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/; // IFSC code format
  const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN format
  const accountNumberPattern = /^[0-9]{9,18}$/; // Account number (9-18 digits)
  const bankNamePattern = /^[a-zA-Z\s]+$/; // Letters and spaces only for Bank Name
  const branchPattern = /^[a-zA-Z\s]+$/; // Letters and spaces only for Branch Name

  // Input Change Handler for Bank Info
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    const updatedBankInfo = { ...bankInfo, [name]: value };
    setBankInfo(updatedBankInfo);

    let newErrors = { ...Bankerrors };

    switch (name) {
        case 'BankAccountNo':
            if (!value) {
                newErrors.BankAccountNo = "Account Number is required.";
            } else if (!accountNumberPattern.test(value)) {
                newErrors.BankAccountNo = "Invalid Account Number. It should be 9 to 18 digits.";
            } else {
                delete newErrors.BankAccountNo; // ✅ Remove error if valid
            }
            break;

        case 'BankName':
            if (!value) {
                newErrors.BankName = "Bank Name is required.";
            } else if (!bankNamePattern.test(value)) {
                newErrors.BankName = "Invalid Bank Name. Only letters and spaces allowed.";
            } else {
                delete newErrors.BankName;
            }
            break;

        case 'IFCcode':
            if (!value) {
                newErrors.IFCcode = "IFSC Code is required.";
            } else if (!ifscPattern.test(value)) {
                newErrors.IFCcode = "Invalid IFSC Code. Format should be like 'ABCD0123456'.";
            } else {
                delete newErrors.IFCcode;
            }
            break;

        case 'Branch':
            if (!value) {
                newErrors.Branch = "Branch Name is required.";
            } else if (!branchPattern.test(value)) {
                newErrors.Branch = "Invalid Branch Name. Only letters and spaces allowed.";
            } else {
                delete newErrors.Branch;
            }
            break;

        case 'PanNumber':
            if (!value) {
                newErrors.PanNumber = "PAN Number is required.";
            } else if (!panPattern.test(value)) {
                newErrors.PanNumber = "Invalid PAN Number. Format should be like 'ABCDE1234F'.";
            } else {
                delete newErrors.PanNumber;
            }
            break;

        default:
            break;
    }

    setBankErrors(newErrors);

    // ✅ Check if all fields are valid
    const requiredFields = ['BankAccountNo', 'BankName', 'IFCcode', 'Branch', 'PanNumber'];
    const allFieldsValid = requiredFields.every((field) => 
        updatedBankInfo[field] && !newErrors[field]
    );

    setIsBankInfoFormValid(allFieldsValid);
};

  const handleBankInfoSubmit = async (e) => {
    e.preventDefault();
    let newErrors = { ...Bankerrors };
    // Check if each required field has a value
    if (!bankInfo.BankAccountNo) newErrors.BankAccountNo = "Account Number is required.";
    if (!bankInfo.BankName) newErrors.BankName = "Bank Name is required.";
    if (!bankInfo.IFCcode) newErrors.IFCcode = "IFSC Code is required.";
    if (!bankInfo.Branch) newErrors.Branch = "Branch Name is required.";
    if (!bankInfo.PanNumber) newErrors.PanNumber = "PAN Number is required.";

    setBankErrors(newErrors);


    const noErrors = Object.keys(newErrors).length === 0;

    const input = {
      BankAccountNo: bankInfo.BankAccountNo,
      BankName: bankInfo.BankName,
      IFCcode: bankInfo.IFCcode,
      Branch: bankInfo.Branch,
      PanNumber: bankInfo.PanNumber,
    }
    try {
      const val = await handleSubmit({
        noErrors,
        formValid: isBankInfoFormValid,
        dataObj: input,
        action: "Bankinfo",
        ModalName: "BankModalpopup",
        submitAction: "handleBankInfoSubmit",
      });
      if (val) {
        dispatch(setBankInfos(bankInfo));
        setIsBankInfoFormValid(false)
      }
    } 
         
   catch (error) {
    } finally {
      setIsBankInfoFormValid(false); // Ensure form state resets
    }
  };
  return (
    <>
      <Modal id="bank_info_modal"
       title="Bank Information"
        handleModalClose={() => handleClose(bankInfoup,
          setBankInfo,
          setBankErrors)}
           handleSubmit={handleBankInfoSubmit}
            onChange={handleBankInputChange}
             isUserDataValid={false}>
        <div className="row">
          <div className="col-md-6 mb-2">
            <InputField
              label="Account Number"
              required={true}
              type="text"
              error={Bankerrors?.BankAccountNo}
              name="BankAccountNo"
              value={bankInfo?.BankAccountNo}
              onChange={handleBankInputChange}
            />
          </div>
          {/* Bank Name */}
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Bank Name"
              required={true}
              type="text"
              name="BankName"
              value={bankInfo?.BankName}
              onChange={handleBankInputChange}
              error={Bankerrors?.BankName}
            />
          </div>

          {/* IFSC Code */}
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="IFSC Code"
              required={true}
              type="text"
              name="IFCcode"
              value={bankInfo?.IFCcode}
              onChange={handleBankInputChange}
              error={Bankerrors?.IFCcode}
            />
          </div>

          {/* Branch Name */}
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Branch Name"
              required={true}
              type="text"
              name="Branch"
              value={bankInfo?.Branch}
              onChange={handleBankInputChange}
              error={Bankerrors?.Branch}
            />
          </div>

          {/* PAN Number */}
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="PAN Number"
              required={true}
              type="text"
              name="PanNumber"
              value={bankInfo?.PanNumber}
              onChange={handleBankInputChange}
              error={Bankerrors?.PanNumber}
            />

          </div>
        </div>
      </Modal>
    </>

  )
}